import React from "react";
import AppChip from "../../common/app-chip";

// Colours from the Campaigns (Beta) mockup
const CHANNEL_STYLES = {
  whatsapp: { label: "WhatsApp", bg: "#E3F3E6", color: "#1E7B34" },
  rcs: { label: "RCS", bg: "#E7EEFB", color: "#1D4ED8" },
};

const STATUS_STYLES = {
  active: { label: "Active", bg: "#2F7D32", color: "#fff" },
  completed: { label: "Completed", bg: "#EDEFF3", color: "#5C6472" },
  success: { label: "Success", bg: "#2F7D32", color: "#fff" },
  scheduled: { label: "Scheduled", bg: "#FBF0DE", color: "#8A5A0B" },
  in_progress: { label: "In progress", bg: "#E7EEFB", color: "#1D4ED8" },
  created: { label: "Created", bg: "#EDEFF3", color: "#5C6472" },
  failed: { label: "Failed", bg: "#FBE7E6", color: "#B3261E" },
  cancelled: { label: "Cancelled", bg: "#EDEFF3", color: "#5C6472" },
};

export const ChannelBadge = ({ channel }) => {
  const style = CHANNEL_STYLES[channel] || { label: channel, bg: "#EDEFF3", color: "#5C6472" };
  return <AppChip label={style.label} sx={{ bgcolor: style.bg, color: style.color }} />;
};

export const StatusBadge = ({ status }) => {
  const style = STATUS_STYLES[status] || { label: status, bg: "#EDEFF3", color: "#5C6472" };
  return <AppChip label={style.label} sx={{ bgcolor: style.bg, color: style.color }} />;
};

// Campaign progress: how its broadcasts are spread across statuses (only non-zero ones are shown)
const PROGRESS_ORDER = [
  { key: "success", label: "Success", bar: "#2F7D32", bg: "#E3F3E6", color: "#1E7B34" },
  { key: "in_progress", label: "In progress", bar: "#2563EB", bg: "#E1ECFD", color: "#1D4ED8" },
  { key: "created", label: "Created", bar: "#9AA0AC", bg: "#EDEFF3", color: "#5C6472" },
  { key: "scheduled", label: "Scheduled", bar: "#E0A63A", bg: "#FBF0DE", color: "#8A5A0B" },
  { key: "failed", label: "Failed", bar: "#C0554B", bg: "#FBE7E6", color: "#B3261E" },
  { key: "cancelled", label: "Cancelled", bar: "#C7C9D1", bg: "#EDEFF3", color: "#5C6472" },
];

export const ProgressBar = ({ counts = {} }) => {
  const parts = PROGRESS_ORDER.filter((p) => counts[p.key]);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 180 }}>
      <div style={{ display: "flex", gap: 2, height: 6, borderRadius: 999, overflow: "hidden", background: "#EDEFF3" }}>
        {parts.map((p) => (
          <span key={p.key} style={{ flex: counts[p.key], minWidth: 4, background: p.bar }} />
        ))}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "4px 6px" }}>
        {parts.map((p) => (
          <AppChip key={p.key} label={`${counts[p.key]} ${p.label}`} sx={{ bgcolor: p.bg, color: p.color, height: 20, fontSize: 11 }} />
        ))}
      </div>
    </div>
  );
};
